import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import ReactGA from 'react-ga'
import services from '../config/services'

const defaultService = services.find(service => service.name === 'LandDeformation') || services[0]
// const defaultService = services[0]

// Redux type and action creators
const { Types, Creators } = createActions({
  layerConfigurationToggled: [],
  locationConfigurationToggled: [],
  locationSelectedChanged: ['name'],
  weatherToggled: [],
  serviceDrawerOpened: [],
  serviceDrawerClosed: [],
  serviceDrawerToggled: [],
  serviceUpdateRequested: ['service'],
  serviceUpdateFulfilled: ['service'],
  serviceUpdateFailed: ['error'],
  serviceCardChanged: ['service'],
  serviceAuthorizationUpdated: [],
  serviceCardMounted: ['service'],
  serviceReset: [],
  reset: []
})

export const ServiceTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  serviceDrawerOpen: true,
  layerConfigurationOpen: true,
  locationConfigurationOpen: false,
  weatherOpen: false,
  coordinatesOpen: true,
  fetching: false,
  loaded: false,
  services: services,
  layers: defaultService.layers.map(layer => layer.name),
  serviceCardActive: defaultService,
  locationSelected: '',
  error: null
})

// Redux reducers
export const layerConfigurationToggled = (state, action) => {
  const { layerConfigurationOpen } = state
  return state.merge({ layerConfigurationOpen: !layerConfigurationOpen })
}

export const locationConfigurationToggled = (state, action) => {
  const { locationConfigurationOpen } = state
  return state.merge({ locationConfigurationOpen: !locationConfigurationOpen })
}

export const locationSelectedChanged = (state, { name }) => {
  return state.merge({ locationSelected: name })
}

export const weatherToggled = (state, action) => {
  const { weatherOpen } = state
  return state.merge({ weatherOpen: !weatherOpen })
}

export const serviceDrawerOpened = (state, action) => {
  return state.merge({ serviceDrawerOpen: true })
}

export const serviceDrawerClosed = (state, action) => {
  return state.merge({ serviceDrawerOpen: false })
}

export const serviceDrawerToggled = (state, action) => {
  const { serviceDrawerOpen } = state
  return state.merge({ serviceDrawerOpen: !serviceDrawerOpen })
}

export const serviceUpdateRequested = state => {
  return state.merge({ fetching: true })
}

export const serviceUpdateFulfilled = (state, { service }) => {
  const title = service.WMT_MS_Capabilities.Capability.Layer.Title

  const prevServices = state.services.filter(
    service => service.WMT_MS_Capabilities.Capability.Layer.Title !== title
  )
  const services = [service, ...prevServices]
  return state.merge({ services, fetching: false })
}

export const serviceUpdateFailed = (state, { error }) => {
  console.log(error)
  return state.merge({ error, fetching: false })
}

export const serviceCardChanged = (state, { service={} }) => {
  // const serviceNext = typeof(service) === 'string'
  //       ? state.services.find(item => item.name === service)
  //       : service

  const serviceNext = state.services.find(item => item.name === service.name)
  if (!serviceNext) {
    return state
  }
  const { layers } = serviceNext
  if (!layers) {
    return state
  }
  ReactGA.modalview(serviceNext.name)
  const layerNames = layers.map(layer => layer.name)
  return state.merge({ serviceCardActive: serviceNext, layers: layerNames })
}

export const serviceCardMounted = (state, { service }) => {
  return state
}

export const serviceReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LAYER_CONFIGURATION_TOGGLED]: layerConfigurationToggled,
  [Types.LOCATION_CONFIGURATION_TOGGLED]: locationConfigurationToggled,
  [Types.LOCATION_SELECTED_CHANGED]: locationSelectedChanged,
  [Types.WEATHER_TOGGLED]: weatherToggled,
  [Types.SERVICE_DRAWER_OPENED]: serviceDrawerOpened,
  [Types.SERVICE_DRAWER_CLOSED]: serviceDrawerClosed,
  [Types.SERVICE_DRAWER_TOGGLED]: serviceDrawerToggled,
  [Types.SERVICE_UPDATE_REQUESTED]: serviceUpdateRequested,
  [Types.SERVICE_UPDATE_FULFILLED]: serviceUpdateFulfilled,
  [Types.SERVICE_UPDATE_FAILED]: serviceUpdateFailed,
  [Types.SERVICE_CARD_CHANGED]: serviceCardChanged,
  [Types.SERVICE_CARD_MOUNTED]: serviceCardMounted,
  [Types.SERVICE_RESET]: serviceReset,
  [Types.RESET]: serviceReset
})



// WEBPACK FOOTER //
// ./src/redux/serviceRedux.js